import { SetStateAction } from "react";
import { IProduct } from "../types/types";
import { ShoppingListItem } from "./ShoppingListItem";
import { useProducts } from "../hooks/useProducts";
import { Spinner } from "./spinner/Spinner";
import { BottomSheet } from "./BottomSheet";

interface IProductListDialogProps {
  products: IProduct[],
  setProducts: (value: SetStateAction<IProduct[]>) => void,
  closeProductList: () => void,
  isOpen: boolean,
  openProductList: () => void
}

const sortProducts = (allProducts: IProduct[], products: IProduct[]) => allProducts.map((product) => {
  const existedProductQuantity = products.find(({ name }) => name === product.name)?.quantity;
  return { ...product, quantity: existedProductQuantity || 0 }
}).sort((a, b) => {
  const aHasQty = a.quantity > 0;
  const bHasQty = b.quantity > 0;

  return Number(bHasQty) - Number(aHasQty);
})

export const ProductListDialog = ({ products, setProducts, closeProductList, openProductList, isOpen }: IProductListDialogProps) => {
  const { products: allProducts, loading, error } = useProducts();

  return (
    <BottomSheet isOpen={isOpen} handleOpen={openProductList} handleClose={closeProductList}>
      <>
        {error && <h2 style={{ display: 'flex', justifyContent: 'center' }}>Nie udało się pobrać produtków</h2>}
        {loading ? (
          <Spinner />
        ) : (
          <ul style={{ listStyle: "none", paddingLeft: 0, height: "100%", overflow: "auto" }}>
            <li style={{ textAlign: "center" }}>Produkty lokalne</li>
            {sortProducts(allProducts.filter((p) => !p.productId), products).map((product) => {
              return (
                <li key={product.name}>
                  <ShoppingListItem product={product} setProducts={setProducts} isDialog />
                </li>
              )
            })}
            <li style={{ textAlign: "center", marginTop: 16 }}>Produkty sklepowe</li>
            {sortProducts(allProducts.filter((p) => p.productId), products).map((product) => {
              return (
                <li key={product.name}>
                  <ShoppingListItem product={product} setProducts={setProducts} isDialog />
                </li>
              )
            })}
          </ul>
        )}
      </>
    </BottomSheet>
  )
}
